import { call, put, takeLatest } from "redux-saga/effects";
import { cauHoiApi } from "../../../api/cau-hoi/cauHoiApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eCauHoiActionIds,
  ICauHoiActionTypes,
} from "../../action-types/cau-hoi/ICauHoiActions";
import { rootActions } from "../../actions/rootActions";
import { ICauHoiSelectRequest } from "../../../model/request/cau-hoi/ICauHoiSelectRequest";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { Download } from "../../../helpers/download";
import { ITongHopCauHoiRequest } from "../../../model/request/cau-hoi/ITongHopCauHoiRequest";
import { ICauHoiProgressRequest } from "../../../model/request/cau-hoi/ICauHoiProgressRequest";

export function* cauHoiSaga(): any {
  yield takeLatest(eCauHoiActionIds.LOAD_START, loadWorker);
  yield takeLatest(eCauHoiActionIds.DELETE_START, deleteWorker);
  yield takeLatest(eCauHoiActionIds.DELETES_START, deletesWorker);
  yield takeLatest(eCauHoiActionIds.SAVE_START, saveWorker);
  yield takeLatest(eCauHoiActionIds.IMPORT_WORD_START, importWordWorker);
  yield takeLatest(
    eCauHoiActionIds.CHECK_DUPLICATE_START,
    checkDuplicateWorker,
  );
  yield takeLatest(eCauHoiActionIds.LOAD_TONGHOP_START, loadTongHopWorker);
  yield takeLatest(eCauHoiActionIds.PROGRESS_START, progressWorker);
  yield takeLatest(eCauHoiActionIds.CHANGE_SU_DUNG_START, changeSuDungWorker);
}

function* loadWorker(action: ICauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauHoiApi.SelectPaging,
    action.payload as ICauHoiSelectRequest,
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.cauHoi.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.cauHoi.cauHoi.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: ICauHoiActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as FormData;
  // Parse payload nếu nó là chuỗi

  const submitData = payload.get("json");
  const data = JSON.parse(submitData as string) as any;

  if (data.question.id > 0) {
    res = yield call(cauHoiApi.Update, payload);
  } else {
    res = yield call(cauHoiApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.cauHoi.cauHoi.SAVE_SUCCESS(res.data));
    } else {
      yield put(rootActions.cauHoi.cauHoi.SAVE_ERROR(res.message ?? "Có lỗi"));
    }
  }
}

function* deleteWorker(action: ICauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauHoiApi.Delete,
    action.payload as number,
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.cauHoi.DELETE_SUCCESS(res.data));
  } else {
    yield put(rootActions.cauHoi.cauHoi.DELETE_ERROR(res.message ?? "Có lỗi"));
  }
}

function* deletesWorker(action: ICauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauHoiApi.Deletes,
    action.payload as number[],
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.cauHoi.DELETES_SUCCESS(res.data));
  } else {
    yield put(rootActions.cauHoi.cauHoi.DELETES_ERROR(res.message ?? "Có lỗi"));
  }
}

function* importWordWorker(action: ICauHoiActionTypes): any {
  const res = yield call(
    cauHoiApi.ImportWord,
    action.payload as IProcessRequest<FormData>,
  );
  if (res === true) {
    yield put(rootActions.cauHoi.cauHoi.IMPORT_WORD_SUCCESS(undefined));
  } else {
    yield put(rootActions.cauHoi.cauHoi.IMPORT_WORD_ERROR(res.message));
  }
}

function* checkDuplicateWorker(action: ICauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauHoiApi.CheckDuplicate,
    action.payload as ICauHoiSelectRequest,
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.cauHoi.CHECK_DUPLICATE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.cauHoi.cauHoi.CHECK_DUPLICATE_ERROR(res.message ?? "Có lỗi"),
    );
  }
}

function* loadTongHopWorker(action: ICauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauHoiApi.TongHop,
    action.payload as ITongHopCauHoiRequest,
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.cauHoi.LOAD_TONGHOP_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.cauHoi.cauHoi.LOAD_TONGHOP_ERRR(res.message ?? "Có lỗi"),
    );
  }
}

function* progressWorker(action: ICauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauHoiApi.Progress,
    action.payload as ICauHoiProgressRequest,
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.cauHoi.PROGRESS_SUCCESS(undefined));
  } else {
    yield put(
      rootActions.cauHoi.cauHoi.PROGRESS_ERRR(res.message ?? "Thất bại"),
    );
  }
}

function* changeSuDungWorker(action: ICauHoiActionTypes): any {
  const res: IBaseRespone = yield call(
    cauHoiApi.ChangeUse,
    action.payload as number,
  );
  if (res.is_success) {
    yield put(rootActions.cauHoi.cauHoi.CHANGE_SU_DUNG_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.cauHoi.cauHoi.CHANGE_SU_DUNG_ERROR(res.message ?? "Có lỗi"),
    );
  }
}
